/**
 * Utility class for formatting phone numbers consistently across the application
 */
export class PhoneFormatterUtil {
  
  /**
   * Formats a phone number string to US format +1-(XXX) XXX-XXXX
   * @param phoneNumber - Raw phone number string (e.g., "+1-89326958639", "89326958639")
   * @returns Formatted phone number string (e.g., "+1-(893) 269-5863")
   */
  static formatPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return '';
    
    // Remove all non-digit characters except the leading +1
    let cleaned = phoneNumber.replace(/[^\d+]/g, '');
    
    // Remove +1 prefix if present
    if (cleaned.startsWith('+1')) {
      cleaned = cleaned.substring(2);
    } else if (cleaned.startsWith('1') && cleaned.length > 10) {
      // Remove leading 1 if it's a US number with country code
      cleaned = cleaned.substring(1);
    }
    
    // Take only first 10 digits
    cleaned = cleaned.substring(0, 10);
    
    // Format as +1-(XXX) XXX-XXXX
    if (cleaned.length >= 6) {
      return `+1-(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
    } else if (cleaned.length >= 3) {
      return `+1-(${cleaned.substring(0, 3)}) ${cleaned.substring(3)}`;
    } else if (cleaned.length > 0) {
      return `+1-(${cleaned}`;
    }
    
    return cleaned;
  }
  /**
   * Removes formatting from phone number to get raw digits
   * @param formattedPhone - Formatted phone number (e.g., "+1-(893) 269-5863")
   * @returns Raw phone number string (e.g., "8932695863")
   */
  static unformatPhoneNumber(formattedPhone: string): string {
    if (!formattedPhone) return '';
    
    // Remove all non-digit characters
    return formattedPhone.replace(/\D/g, '');
  }
}
